import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[editMode]',
})
export class EditModeDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
